var map = {
	"./en/king_card_2.png": "ZThn",
	"./es/king_card_2.png": "K5M0",
	"./pt/king_card_2.png": "PfsN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gV2L";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/king_card_2\.png$
// module id = gV2L
// module chunks = 0